import { Avatar, Badge, Button, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Popover, Tooltip, Typography } from "@material-ui/core";
import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import EventLabel2 from "../../../../../components/EventLabel2/EventLabel2";
import { combineProps } from "../../../../../helpers/objectHelper";
import { ChatAvatar } from "../ChatAvatar";
import { makeStyles } from "@material-ui/core/styles";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    pointerEvents: "auto",
    padding: theme.spacing(1),
  },
}));

export function PersonInformationPopover(props) {
  const classes = useStyles();

  const [popoverOpen, setPopoverOpen] = useState(false);
  const popoverAnchor = useRef(null);

  const { children, target, orderList = [], preview, show = true, attendee = null } = props;

  const handlePopoverOpen = (event) => {
    setPopoverOpen(true);
  };
  const handlePopoverClose = (event) => {
    setPopoverOpen(false);
  };
  let person = null;
  if (!attendee) person = orderList.find((o) => o.badgeNo == target);
  else person = attendee;
  if (!person || preview || !show) return children;

  return (
    <div>
      <div ref={popoverAnchor} aria-owns={popoverOpen ? "mouse-over-popover" : undefined} aria-haspopup="true" onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        {children}
      </div>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.popoverContent,
        }}
        open={popoverOpen}
        anchorEl={popoverAnchor.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        PaperProps={{
          onMouseEnter: handlePopoverOpen,
          onMouseLeave: handlePopoverClose,
        }}
      >
        <PersonDetailsItem {...combineProps([props, { person }])} />
      </Popover>
    </div>
  );
}

const PersonDetailsItem = (props) => {
  const { person, target, chatTemplate, selectChat, template } = props;
  const { primaryColor, secondaryColor } = chatTemplate;
  const titleStyle = {
    fontSize: "1.1rem",
    color: "#222",
  };
  return (
    <List style={{ minWidth: 300, padding: 0 }}>
      <div className="user-card-preview">
        <div
          className="brand-header"
          style={{
            background: template ? template.main.background : "#3f51b5",
          }}
        ></div>
        <div className="user-image">
          <Avatar
            src={person.profileImage}
            style={{
              height: "100px",
              width: "100px",
              marginTop: "-3px",
              margin: "auto",
              border: "3px solid #fff",
              color: secondaryColor,
              backgroundColor: person.profileImage ? "#fff" : primaryColor,
            }} /* {...combineProps([props, chatTemplate])} */
          >
            {person.nameInitials}
          </Avatar>
        </div>
        <div className="user-text">
          <div className="name">{person.name}</div>
          {person.title ? <div className="title">{person.title}</div> : null}
          {person.company ? (
            <div className="company" style={{ color: primaryColor }}>
              {person.company}
            </div>
          ) : null}
        </div>
      </div>
      {/* <ListItem>
        <ListItemAvatar></ListItemAvatar>
        <ListItemText
          primary={<div style={titleStyle}>{person.name}</div>}
          secondary={<PersonDescription {...props} />}
        />
      </ListItem> */}
      <div style={{ padding: "0px 12px", display: "flex" }}>
        <Button
          onClick={() => selectChat(target || person.badgeNo)}
          style={{
            color: secondaryColor,
            backgroundColor: primaryColor,
            padding: "6px 12px",
            width: !person.linkedIn ? "100%" : `calc(100% - 36.5px)`,
            margin: 5,
          }}
          startIcon={<ChatBubbleIcon />}
        >
          <EventLabel2 groupName="DigitalMeeting.Chat" name="Chat" />
        </Button>

        {person.linkedIn ? (
          <Button
            onClick={() => window.open(person.linkedIn, "_blank")}
            variant="contained"
            color="default"
            style={{
              backgroundColor: "#eee",
              padding: "6px 12px",
              margin: 5,
              boxShadow: "none",
            }}
          >
            <Tooltip title={person.linkedIn}>
              <LinkedInIcon />
            </Tooltip>
          </Button>
        ) : null}
      </div>
    </List>
  );
};
function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}

export default connect(mapStateToProps)(PersonInformationPopover);
